export default "__VITE_ASSET__fe6b754c__"